module.exports = __webpack_public_path__ + "static/media/img-3.6db7913d.jpg";